/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2014, Bulb Inc.  For more information, please email contact@hellobulb.com.
 */
'use strict';

angular.module('bulbApp.animationModule')
.directive('mobileTabAnimations', ['$timeout', mobileTabAnimations]);

function mobileTabAnimations($timeout) {
  return function(scope, element, attrs) {
        var cloneHeader;
        var jqAccordion = jQuery('#mobileTabContainer').find('.accordion');
        var jqActiveHeader = jQuery(element.children()[0]);

        function removeClone() {
            jqAccordion.find('.bulb-locked-header').remove();
            cloneHeader = null;
            jqAccordion.find('dd > a.bulb-hidden').removeClass('bulb-hidden');
        }

    scope.$watch(attrs.mobileTabAnimations, function(newVal) {
      //clear old selections
      jQuery(window).unbind('scroll.mobileTab');
      jQuery(window).scrollTop(0);
      //remove any old sticky headers
            if(cloneHeader !== null) {
                removeClone();
            }
            if(newVal) {
                $timeout(function(){   //Set timeout for animation, so that the previous tab can close first
                    var offSet = jqAccordion.offset().top - jqActiveHeader.offset().top;

                    //slide to the top of the page
                    jqAccordion.css({
                        marginTop: offSet
                    });
                    //Sticky header
                    jQuery(window).bind('scroll.mobileTab', function(){
                        var stickToTop = jQuery(window).scrollTop() > jqActiveHeader.offset().top;
                        if(stickToTop && !cloneHeader) {
                            cloneHeader = jqActiveHeader.clone();
                            cloneHeader.addClass('bulb-locked-header');
                            cloneHeader.appendTo(jqActiveHeader.parent());
                            cloneHeader.click(function(event) {
                                event.stopImmediatePropagation();
                                jqActiveHeader.click();
                            });
                            jqActiveHeader.addClass('bulb-hidden');
                        } else if(!stickToTop && cloneHeader) {
                            removeClone();
                        }
                    });
                }, 100);
            } else {
                //If there is no active element then slide the accordion down
                jqAccordion.css({
                    marginTop: '0'
                });
            }
    });
  };
}
